// localStorage persistence layer. All data stays in the browser.
const USERS_KEY = "scholavia:users";
const SESSION_KEY = "scholavia:session";
const dataKey = (uid) => `scholavia:data:${uid}`;

const read = (k, fallback) => {
  try {
    const v = localStorage.getItem(k);
    return v ? JSON.parse(v) : fallback;
  } catch {
    return fallback;
  }
};
const write = (k, v) => localStorage.setItem(k, JSON.stringify(v));

export const store = {
  getUsers: () => read(USERS_KEY, []),
  saveUsers: (u) => write(USERS_KEY, u),
  getSession: () => read(SESSION_KEY, null),
  setSession: (uid) => write(SESSION_KEY, uid),
  clearSession: () => localStorage.removeItem(SESSION_KEY),
  getData: (uid) => read(dataKey(uid), defaultData()),
  setData: (uid, data) => write(dataKey(uid), data),
};

export function defaultData() {
  return {
    profile: {
      name: "", education: "", degreeTarget: "", field: "", gpa: "",
      language: "IELTS", languageScore: "", experience: "", experienceYears: "",
      achievements: "", countries: "", budget: "", targetIntake: "", careerGoal: "",
    },
    onboardingComplete: false,
    savedScholarships: [],
    testAttempts: [],
    completedTasks: [],
    costPrefs: null,
    preferences: {},
  };
}
